import React, { useEffect, useRef } from "react";
import { Form, Input, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";

const { TextArea } = Input;

const ShareJobModal = ({ open, handleCancel, activeObjJob }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { saving } = useSelector((state) => state.save);

  // let shareUrl = `http://localhost:3000/#/recruitment/career-view-list/#/shared-job/${activeObjJob?.jobId}/${activeObjJob?.jobTitle}`;
  let shareUrl = `https://app.ndovuhr.com/#/recruitment/career-view-list/#/shared-job/${activeObjJob?.jobId}/${activeObjJob?.jobTitle}`;
  let title = activeObjJob?.jobTitle;

  useEffect(() => {}, [activeObjJob]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={"Share Job"}
        open={open}
        // onOk={handleSubmit}
        onCancel={handleCancel}
        width={580}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          // onFinish={handleSubmit}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="text-[#0E0E0E] text-[.875rem] font-[400] font-dmSans mb-2">
            Choose platform to share
          </div>

          <div className="flex justify-evenly max-w-full   mt-[1rem]">
            <FacebookShareButton url={shareUrl}>
              <FacebookIcon size={50} round />
            </FacebookShareButton>

            <FacebookMessengerShareButton
              url={shareUrl}
              appId="521270401588372"
            >
              <FacebookMessengerIcon size={50} round />
            </FacebookMessengerShareButton>

            <TwitterShareButton url={shareUrl}>
              <XIcon size={50} round />
            </TwitterShareButton>

            <TelegramShareButton url={shareUrl}>
              <TelegramIcon size={50} round />
            </TelegramShareButton>

            <WhatsappShareButton url={shareUrl}>
              <WhatsappIcon size={50} round />
            </WhatsappShareButton>

            <LinkedinShareButton url={shareUrl}>
              <LinkedinIcon size={50} round />
            </LinkedinShareButton>

            <EmailShareButton url={shareUrl} subject={title} body="body">
              <EmailIcon size={50} round />
            </EmailShareButton>
          </div>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[150px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn-2"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[150px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Share"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default ShareJobModal;
